import { FundingType } from '@common/enums';
import { ConfirmationModal } from '@frontend/components/elements/modals/ConfirmationModal';
import { FinancialLogMutationModal } from '@frontend/components/elements/modals/FinancialLogMutationModal';
import { getSelectedLanguage } from '@frontend/translate';

interface IFinancingConfirmationModalProps {
    numberOfActivitiesToReprocess: number;
    onClose: () => Promise<void>;
    onReprocessDeclarations: (reprocessReason?: string) => Promise<void>;
    selectedFundingTypeAction: FundingType | null;
    showConfirmation: boolean;
}

export function FinancingReprocessConfirmationModal(props: IFinancingConfirmationModalProps) {
    const language = getSelectedLanguage();

    if (props.selectedFundingTypeAction === FundingType.freeOfCharge) {
        return (
            <FinancialLogMutationModal
                handleNo={() => props.onClose()}
                handleYes={async (reason) => {
                    await props.onReprocessDeclarations(reason);
                }}
                isOpen={props.showConfirmation}
            />
        );
    } else {
        return (
            <ConfirmationModal
                handleNo={() => props.onClose()}
                handleYes={async () => {
                    await props.onReprocessDeclarations();
                }}
                isOpen={props.showConfirmation}
                question={`Weet je zeker dat je ${props.numberOfActivitiesToReprocess} opnieuw wilt verwerken? Door de pagina te verlaten of te annuleren wordt de herverwerking gestopt en kun je op een ander moment verdergaan.`}
                title={language.common.notice}
            />
        );
    }
}
